import { InsightCatalogue } from '../InsightCatalogue';
import {
  InsightMetric,
  BaseInsightPayload,
  validateInsightStructure,
  FullInsightPayload,
} from '../InsightDataPayload';

export interface UserUtilizationPayload extends FullInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION;
    id: string;
    attributes: {
      data: Array<{
        user_id: string;
        user_name: string;
        task_utilization_percent: number;
        event_utilization_percent: number;
        target_utilization_percent: number;
      }>;
      aggregate: {
        average_utilization_percent: InsightMetric;
        target_utilization_percent: InsightMetric;
      };
    };
  };
}

type UserUtilizationData = {
  data: Array<{
    user_id: string;
    user_name: string;
    utilization_breakdown: {
      task: {
        actual_hours_in_range: number;
        utilization_percent: number;
      };
      event: {
        scheduled_hours_in_range: number;
        utilization_percent: number;
      };
    };
    overall_utilization_percent: number;
  }>;
  aggregate: {
    average_utilization_percent: InsightMetric;
    target_utilization_percent: InsightMetric;
  };
};

export const parseUserUtilizationPayload = (
  payload: BaseInsightPayload
): UserUtilizationPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION,
    data.attributes,
    true,
    true,
    ['average_utilization_percent', 'target_utilization_percent']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as UserUtilizationData;

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_USER_UTILIZATION,
      id: data.id,
      attributes: {
        data: typedAttributes.data.map((item) => ({
          user_id: item.user_id,
          user_name: item.user_name,
          task_utilization_percent:
            item.utilization_breakdown.task.utilization_percent,
          event_utilization_percent:
            item.utilization_breakdown.event.utilization_percent,
          overall_utilization_percent: item.overall_utilization_percent,
          target_utilization_percent:
            typedAttributes.aggregate.target_utilization_percent.current || 80,
        })),
        aggregate: {
          average_utilization_percent:
            typedAttributes.aggregate.average_utilization_percent,
          target_utilization_percent:
            typedAttributes.aggregate.target_utilization_percent,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
